module.exports = __webpack_public_path__ + "static/img/oddnary-sunset-orange-scheme.ec95b8e2.jpg";